// extracted by mini-css-extract-plugin
export var bodyRow = "_eh-d";
export var cardColumns = "_eh-e";
export var ellipsesOverflow = "_eh-2";
export var flatBottomCorners = "_eh-3";
export var flatTopCorners = "_eh-4";
export var headerActionsDropdown = "_eh-f";
export var headerBottomRow = "_eh-c";
export var headerTopRow = "_eh-b";
export var orderDetailsWrapper = "_eh-0";
export var orderInfoContainer = "_eh-1";
export var productDetails = "_eh-9";
export var productImage = "_eh-5";
export var responsiveTable = "_eh-8";
export var shipmentContainer = "_eh-a";
export var tableBottomLeft = "_eh-6";
export var tableBottomRight = "_eh-7";